export default __webpack_public_path__ + "static/media/marketive.6dc70507.png";